module.exports = __webpack_public_path__ + "img/bk_03.5c6c0d59.png";